// Compact Recharts sparkline for one leaderboard row's cleaned close series.
// The stroke follows the slope: emerald when the latest close is at/above the
// first, rose when it has fallen. Animation is disabled so a table of ~10 of
// these paints instantly.

import { Line, LineChart, ResponsiveContainer, YAxis } from 'recharts';

interface PerformerSparklineProps {
    values: number[];
    width?: number;
    height?: number;
}

export const PerformerSparkline = ({
    values,
    width = 96,
    height = 32,
}: PerformerSparklineProps) => {
    // Need at least two points to draw a meaningful line.
    if (!values || values.length < 2) {
        return (
            <div
                style={{ width, height }}
                className="flex items-center justify-center text-[10px] text-slate-400"
            >
                —
            </div>
        );
    }

    const rising = values[values.length - 1] >= values[0];
    const stroke = rising ? '#10b981' : '#f43f5e'; // emerald-500 / rose-500

    const data = values.map((v, i) => ({ i, v }));

    return (
        <div style={{ width, height }}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    data={data}
                    margin={{ top: 4, right: 2, bottom: 4, left: 2 }}
                >
                    {/* Auto-fit the y-domain so tiny moves are still visible. */}
                    <YAxis hide domain={['dataMin', 'dataMax']} />
                    <Line
                        type="monotone"
                        dataKey="v"
                        stroke={stroke}
                        strokeWidth={1.5}
                        dot={false}
                        isAnimationActive={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PerformerSparkline;
